import { createContext, useContext } from 'react';
import { useTenancy, User } from '@/contexts/TenancyContext';

// Create a context to use in testing or when TenancyContext is not available
const UserUtilsContext = createContext<{ users: User[] }>({ users: [] });

/**
 * Get a user's full name from their user ID
 * This function uses the TenancyContext to look up user information
 * 
 * @param userId The user ID to look up
 * @returns The user's full name (firstName + lastName) or the original ID if not found
 */
export const useGetUserFullName = () => {
  const { users } = useTenancy();
  
  return (userId: string): string => {
    if (!userId) return 'Unassigned';
    
    const user = users.find(u => u.id === userId);
    if (user) {
      return `${user.firstName} ${user.lastName}`.trim() || userId;
    }
    return userId; // Fallback to user ID if user not found
  };
};

/**
 * For testing purposes or when outside of a React component
 */
export const UserUtilsProvider = UserUtilsContext.Provider;
